import { __module as a } from "../../../../_virtual/extends.js";
var p;
function x() {
  return p ? a.exports : (p = 1, function(r) {
    function e() {
      return r.exports = e = Object.assign ? Object.assign.bind() : function(o) {
        for (var t = 1; t < arguments.length; t++) {
          var s = arguments[t];
          for (var n in s) ({}).hasOwnProperty.call(s, n) && (o[n] = s[n]);
        }
        return o;
      }, r.exports.__esModule = !0, r.exports.default = r.exports, e.apply(null, arguments);
    }
    r.exports = e, r.exports.__esModule = !0, r.exports.default = r.exports;
  }(a), a.exports);
}
export {
  x as __require
};
